import { Component } from '@angular/core';
import { RatingComponent } from '@group24ag/flowkit';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-ui-rating',
  imports: [RatingComponent, ReactiveFormsModule],
  template: `
    <div>
      <h1 class="heading-title">Rating</h1>
      <div class="flex flex-col gap-4">
        <div class="flex gap-x-2">
          <flk-rating [formControl]="control1" variant="default" />
          {{ getMSG(control1.getRawValue() ?? 0) }}
        </div>

        <div class="flex gap-x-2">
          <flk-rating [formControl]="control2" variant="default" />
          {{ getMSG(control2.getRawValue() ?? 0) }}
        </div>

        <div class="flex gap-x-2">
          <flk-rating [formControl]="control3" variant="magic" />
          {{ getMSG(control3.getRawValue() ?? 0) }}
        </div>

        <div class="flex gap-x-2">
          <flk-rating [formControl]="control4" variant="magic" />
          {{ getMSG(control4.getRawValue() ?? 0) }}
        </div>
      </div>
    </div>
  `,
})
export class UIRatingComponent {
  protected control3 = this.fb.control(3);
  protected control2 = this.fb.control(4);
  protected control1 = this.fb.control(1);
  protected control4 = this.fb.control(2);
  constructor(private fb: FormBuilder) {
    this.control2.disable();
    this.control4.disable();
  }

  protected getMSG(stars: number) {
    return `You selected ${stars} ${stars !== 1 ? 'stars' : 'star'}`;
  }
}
